<div class="modal-header">
	<h2 class="modal-title" translate="Tiers.DuplicatedTiersDetected"></h2>
	<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
</div>

<div class="modal-body">
	<div [class.block-loader]="loader?.isLoading$ | async">
		<span translate="Tiers.DuplicatedTiersMessage"></span>
		<loader-spinner *ngIf="loader" [model]="loader"></loader-spinner>

		<data-table-v2
			[list]="data"
			[withActions]="false"
			[rowIdPrefix]="'tiers-doublon-row'"
			[currentColumn]="currentConfig"
			[translationPath]="'Tiers.Datagrid.Columns.TiersGrid'"
			[SpecialColumnTreatement]="columnWithSpecificTreatment"
			[columnSettings]="type === tiersType.PersonnePhysique ? columnSettingsPP : columnSettingsPM"
			(selectRowEvent)="onSelectItem($event)"
		>
		</data-table-v2>
	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-secondary" translate="Tiers.IgnoreDoublon" (click)="onIgnore()"></button>
</div>

<ng-template #columnWithSpecificTreatment let-item let-colname="colname" let-row="row">
	<span *ngIf="colname?.name == 'dateNaissance'">{{ item ? (item | dateFormat) : '' }}</span>
	<span *ngIf="colname?.name == 'nationalite' || colname?.name == 'pays'">{{ row.pays?.nom }}</span>
</ng-template>
